import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { SectionRelayDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { TrackerExtraInfoProps } from '@diritto/common/tracker/tracking-event.constant';
import SectionContentLiteTexts from 'app-components/home/sections/SectionContentLiteTexts';
import { isSectionContentDto } from 'utils/sectionContentUtils';

type SectionProps = {
  section: SectionRelayDto;
  contents: Record<number, ContentRelayDto>;
  profileLites: Record<number, ProfileLiteRelayDto>;
};

export const SectionRankLiteTexts = (props: SectionProps & TrackerExtraInfoProps) => {
  if (!isSectionContentDto(props.section)) {
    return null;
  }

  return <SectionContentLiteTexts {...props} section={props.section} />;
};

export default SectionRankLiteTexts;
